"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var runIos_exports = {};
__export(runIos_exports, {
  run: () => run
});
module.exports = __toCommonJS(runIos_exports);
var import_fs = require("fs");
var import_path = require("path");
var import_loadConfig = require("../vite/loadConfig");
async function run(args) {
  var _ref, _process_env, _RCT_METRO_PORT;
  var _options_config_config_server, _options_config_config, _options_config;
  var root = process.cwd();
  var options = await (0, import_loadConfig.loadUserOneOptions)("serve", true).catch(function() {
    return null;
  });
  var port = (_ref = options === null || options === void 0 ? void 0 : (_options_config = options.config) === null || _options_config === void 0 ? void 0 : (_options_config_config = _options_config.config) === null || _options_config_config === void 0 ? void 0 : (_options_config_config_server = _options_config_config.server) === null || _options_config_config_server === void 0 ? void 0 : _options_config_config_server.port) !== null && _ref !== void 0 ? _ref : 8081;
  (_RCT_METRO_PORT = (_process_env = process.env).RCT_METRO_PORT) !== null && _RCT_METRO_PORT !== void 0 ? _RCT_METRO_PORT : _process_env.RCT_METRO_PORT = String(port);
  if (!(0, import_fs.existsSync)((0, import_path.join)(root, "ios"))) {
    var { run: prebuildRun } = await import("./prebuild");
    await prebuildRun({
      platform: "ios"
    });
  }
  var { runIos } = await import("vxrn");
  await runIos({
    root,
    port,
    simulator: args.simulator,
    udid: args.udid
  });
}
//# sourceMappingURL=runIos.js.map
